import { validateEmail } from '../../utils';
import { format, validate } from 'rut.js';


$('.inscriptions').on('input', '.email-field', function (e) {
  this.value = this.value.replaceAll(' ','')
});

$('.inscriptions').on('input', '.email-field-input', function (e) {
  var id = this.id.split('-').slice(-1)[0]
  this.value = this.value.replaceAll(' ','')

  validateEmail(`email-${id}`,`email-confirmation-${id}`)
});

$('.inscriptions').on('input', '.tax_id_input', function (e) {
  let val = format(this.value);
  this.value = val;
});